import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import './CheckEmail.scss';
import Logo2 from '../../../components/Logo/Logo2';

const EmailVerified = () => {
    document.title = 'Password Updated - DB Design';

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email verified'>
                <svg width="62px" height="62px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        {/* <circle cx="12" cy="12" r="10" stroke="rgb(98, 183, 153)" strokeWidth="1.35"></circle> */}
                        <circle cx="12" cy="12" r="10" stroke="#f7f7f7" strokeWidth="1.25"></circle>
                        <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#f7f7f7" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"></path>
                    </g>
                </svg>

                <div className="check-email-title verified">Password Updated</div>
                <div className='check-email-text-wrap verified'>
                    <p className="check-email-text">Your password has been successfully updated.</p>
                </div>
                <a href="/login" className="check-email-action verified">
                    <span>Continue</span>
                </a>
            </div>
        </div >
    );
};

export default EmailVerified;
